export default __webpack_public_path__ + "static/media/locker-main-logo.9defa528.svg";